import * as moment from 'moment';

export class DateFormatValueConverter {
    toView(value) {
        return value ? moment(value).format('MM/DD HH:mm') : "";
    }
}